import { MapMarkerRemoveOutlineIcon } from './MapMarkerRemoveOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 75FDE93C-EB66-4824-9F96-1B4212BDA785
 * name map-marker-remove-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-remove-outline.svg
 * tags
 * - Geographic Information System 
 * - Navigation 
 */
export const LocationRemoveOutlineIcon = MapMarkerRemoveOutlineIcon;
export default LocationRemoveOutlineIcon